<template>
  <div class="messenger">

    <div class="hero">
      <div class="hero-body" style="padding-top: 24px; padding-bottom: 24px;">
        <div class="container">
          <h1 class="title is-size-1" style="color: white;">Broadcast Messages</h1>
          <p class="subtitle" style="color: #bbb;">All Messages</p>
        </div>
      </div>
    </div>

    <div class="container">

      <div v-if="pleaseWait">
        <p>Please wait...</p>
      </div>

      <br/>

      <div>
        <div class="is-pulled-right">
          <span><a @click="addNewMessage" style="color: white" class="is-link">Add new message</a><i class="fas fa-plus-circle has-text-info" @click="addNewMessage" title="ADD NEW MESSAGE"></i></span>
        </div>
      </div>
      
      <div v-if="showAddNew" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <p class="is-size-5 has-text-weight-bold">Post New Message</p>
            <i class="fas fa-times close-icon" @click="cancelNewMessage"></i>
          </div>
          <div class="modal-body">
            <div class="field">
              <label class="label">Message Type:</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="message.level">
                    <option v-for="level in level_list" v-bind:key="level.level_name" v-bind:value="level.level_name">
                      {{ level.level_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="field">
              <label class="label">Subject:</label>
              <div class="control">
                <input type="text" v-model="message.title" class="input" placeholder="Enter subject"/>
              </div>
            </div>
            
            <div class="field">
              <label class="label">Body:</label>
              <div class="control">
                <textarea class="textarea" v-model="message.description" placeholder="Enter message" rows="4"></textarea>
              </div>
            </div>
            
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Start Date:</label>
                  <div class="control">
                    <input class="input" type="date" v-model="message.start_date"/>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">End Date:</label>
                  <div class="control">
                    <input class="input" type="date" v-model="message.end_date"/>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="modal-actions">
              <button class="button is-danger" @click="cancelNewMessage">
                <i class="fas fa-times-circle"></i>
                <span>Cancel</span>
              </button>
              <button class="button is-primary" @click="saveNewMessage">
                <i class="fas fa-save"></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div class="box messages" v-if="messages.length > 0">
        <div v-for="(message,index) in messages" :key="message._id" class="message">
          <div class="message-header">
            <p class="is-size-6">
              <span v-if="message.level === 'livegame'"><i class="fas fa-bullseye"></i></span>
              <span v-if="message.level === 'warning'"><i class="fas fa-skull-crossbones"></i></span>
              <span v-if="message.level === 'feature'"><i class="fas fa-crow"></i></span>
              <span v-if="message.level === 'information'"><i class="fas fa-info"></i></span>
              <span v-if="message.level === 'reminder'"><i class="fas fa-bell"></i></span>
              <span v-if="message.level === 'bug'"><i class="fas fa-bug"></i></span>
              <span>{{ message.title }}</span>
            </p>
          </div>
          <div class="message-body">
            <p class="is-size-6">{{ message.description }}</p>
            <p class="is-size-7 message-date">{{ message.start_date | formatDate }} to {{ message.end_date | formatDate }}</p>
            <div class="message-actions">
              <i class="fas fa-trash has-text-danger" v-on:click="deleteMessage(message,index)" title="DELETE"> </i>
              <span class="has-text-danger is-link" v-on:click="deleteMessage(message,index)">delete</span>
            </div>
          </div>
        </div>

      </div>

    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: 'admin',
    components : {
    },
    computed: {
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
            message: {
              level: "reminder",
              start_date: moment().format('YYYY-MM-DD'),
              end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
              title: '',
              description: ''
            },
            messages: [],
            level_list: [{level_name:'warning'},{level_name:'feature'},{level_name:'information'},{level_name:'reminder'},{level_name:'bug'}],
            errorMessage: '',
            showError: false,
            pleaseWait: true,
            showAddNew: false
        }
    },
    methods:{
      getMessages() {
        var url = (this.debugMode ? "http://localhost:8080/messages/" : "https://axes2api.azurewebsites.net/messages/")
        this.messages = [];
        this.pleaseWait = true;

        axios.get(url)
          .then((response) => {
            // Sort messages by start_date, most recent first
            this.messages = response.data.sort((a, b) => {
              return new Date(b.start_date) - new Date(a.start_date);
            }); 
            this.pleaseWait = false;
          }, (error) => {
            this.pleaseWait = false;
          });
      },
      addNewMessage() {
        this.toggleShowAddNew();
      },
      toggleShowAddNew() {
        this.showAddNew = !this.showAddNew;
      },
      saveNewMessage() {
        var url = (this.debugMode ? "http://localhost:8080/message/" : "https://axes2api.azurewebsites.net/message/")
        var token = this.$parent.getApiToken();
        axios.post(url, 
          {
            title: this.message.title,
            description: this.message.description,
            level: this.message.level,
            start_date: this.message.start_date,
            end_date: this.message.end_date
          },
          {
            headers: {
                authorization: token
              }
          }
        )
        .then((response) => {
          alert("Message added.");      
          this.messages.push(this.message);      
          this.message = {};
          this.toggleShowAddNew();
       }, (error) => {
          alert("Error adding message to Axes2.");
        });
      },
      cancelNewMessage() {
        this.message = {};
        this.toggleShowAddNew();
      },
      editMessage() {
        alert("edit");
      },
      deleteMessage(message, index) {
        if (confirm('Are you sure you want to delete this broadcast message?')) {
          var messageId = message._id;

          var url = (this.debugMode ? "http://localhost:8080/message/" : "https://axes2api.azurewebsites.net/message/")
          url += messageId;
          
          //console.log("deleteMessage url:" + url);

          var token = this.$parent.getApiToken();

          axios.delete(url, {
            headers: {
              authorization: token
            },
            data: {
            }
          })
          .then((response) => {
            alert('Message Deleted.');
            //console.log(response);
            
            this.messages.splice(index, 1);
            
          }, (error) => {
            alert("Error deleting message.");
            console.log(error);
          });
        }
      },
      isAdmin() {
          return this.$parent.isAdmin();
      }
    },
    mounted(){
      this.getMessages();
    }
}
</script>

<style scoped>
  .messenger {
    background-color: #181313;
    min-height: 100vh;
    color: white;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }
  .hero {
    background-color: #2e7d32;
    margin-bottom: 20px;
  }
  .messages {
    background-color: transparent; 
    max-width: 600px; 
    margin: auto;
    margin-bottom: 25px;
    margin-top: 10px;
    border: none;
    box-shadow: none;
  }
  .message {
    background-color: white;
    border-radius: 12px;
    margin-bottom: 16px;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    border: none;
  }
  .message:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  .message-header {
    background: linear-gradient(135deg, #2d5016 0%, #4a7c2f 100%);
    padding: 12px 16px;
  }
  .message-header p {
    color: #f4a300;
    font-weight: 600;
    margin: 0;
  }
  .message-header i {
    color: #f4a300;
    font-size: 1.4em;
    margin-right: 8px;
  }
  .message-body {
    padding: 16px;
    color: #333;
  }
  .message-body p {
    color: #333;
    margin-bottom: 12px;
  }
  .message-date {
    color: #666;
    font-style: italic;
    margin-top: 8px;
  }
  .message-actions {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #e0e0e0;
  }
  .message-actions i {
    cursor: pointer;
  }
  .message-actions span {
    cursor: pointer;
    margin-left: 4px;
  }
  .box {
    color: white;
  }
  .box .box {
    background-color: #1a1a1a;
    border-radius: 8px;
    padding: 20px;
  }
  .box p {
    margin-bottom: 8px;
    font-weight: 500;
  }
  input, textarea, select {
    background-color: #333;
    color: white;
    border: 1px solid #555;
    border-radius: 6px;
    padding: 10px;
    transition: border-color 0.2s;
  }
  input:focus, textarea:focus, select:focus {
    border-color: #4a7c2f;
    outline: none;
  }
  .select.is-rounded select {
    border-radius: 6px;
  }
  .button.is-primary {
    background: linear-gradient(135deg, #2d5016 0%, #4a7c2f 100%);
    border: none;
    font-weight: 600;
  }
  .button.is-primary:hover {
    background: linear-gradient(135deg, #3a6620 0%, #5a8c3f 100%);
  }
  .button.is-danger {
    font-weight: 600;
  }
  ::placeholder {
    color: #888;
  }
  
  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
  }
  .modal-content {
    background-color: white;
    border-radius: 12px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
  .modal-header {
    background: linear-gradient(135deg, #2d5016 0%, #4a7c2f 100%);
    padding: 20px;
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .modal-header p {
    color: #f4a300;
    margin: 0;
  }
  .close-icon {
    color: #f4a300;
    font-size: 1.5em;
    cursor: pointer;
    transition: transform 0.2s;
  }
  .close-icon:hover {
    transform: scale(1.1);
  }
  .modal-body {
    padding: 24px;
    color: #333;
  }
  .field {
    margin-bottom: 20px;
  }
  .label {
    color: #333;
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
  }
  .modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
  }
  .modal-actions .button {
    min-width: 120px;
  }
  .modal-actions .button i {
    margin-right: 8px;
  }
</style>

